<footer class="page-footer-v2">
  <div class="footer-right">
    <button class="btn btn-ghost ui-btn" type="button" (click)="getBatchEventLogs()">
      <app-svg-icon src="assets/icons/reload-icon.svg" width="14px" height="14px"></app-svg-icon>
      Logs
    </button>

    <button *ngIf="allowReturnStatus" class="btn btn-ghost ui-btn" type="button" (click)="returnBatchStatus()">
      <app-svg-icon src="assets/icons/arrow-icon.svg" width="14px" height="14px"></app-svg-icon>
      Voltar Status
    </button>

    <button *ngIf="allowCancelBatch" class="btn btn-danger ui-btn" type="button" (click)="cancelBatch()">
      <app-svg-icon src="assets/icons/circle-xmark.svg" width="14px" height="14px"></app-svg-icon>
      Cancelar Lote
    </button>

    <button *ngIf="allowIntegrationSap" class="btn btn-outline ui-btn ui-btn--secondary" type="button" (click)="integrateSAP()">
      <app-svg-icon src="assets/icons/reload-icon.svg" width="14px" height="14px"></app-svg-icon>
      Integrar OMIE
    </button>

  </div>
</footer>